export const OTHER_ETHNICITY_CODE = '2135-2';

export const ETHNICITY_LIST = [
    {
        label: 'ssap.input.label.cuban',
        code: '2182-4',
        otherLabel: null,
        altName: 'cuban'
    },
    {
        label: 'ssap.input.label.mexican',
        code: '2148-5',
        otherLabel: null,
        altName: 'mexican'
    },
    {
        label: 'ssap.input.label.puerto_rican',
        code: '2180-8',
        otherLabel: null,
        altName: 'puerto_rican'
    },
    {
        label: '',
        code: OTHER_ETHNICITY_CODE,
        otherLabel: null,
        altName: 'other_ethnicity'
    }
];